export enum ConfigurationType {
  'email'     = 'EMAIL',
  'sms'       = 'SMS',
  'whatsapp'  = 'WHATSAPP',
  'hr'        = 'HR',
  'conf'      = 'CONF',
  'bacheca'   = 'BACHECA',
}
